import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true, state: {
        loading: false,
        sending_contribution_request: false,
        sending_report_email: false,
        payments: {data: [], current_page: 1, total: 0, per_page: 10},
        payment: [],
        payment_request: {
            message: ''
        },
        checkout_message: {
            message: ''
        },
        payment_request_error: {
            message: ''
        },
        errors: {
            data: {
                errors: {
                    phone_number: [],
                    reference_no: [],
                    payment_date: [],
                    amount: [],
                    id_number: [],
                    tenant_id: [],
                    source_number: [],
                    value_date: [],
                    channel: [],
                    transaction_type: []
                }
            }
        },
        has_errors: false,
    }, getters: {
        loading: state => state.loading,
        payment: state => state.payment,
        payments: state => state.payments,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
        sending_report_email: state => state.sending_report_email,
        sending_contribution_request: state => state.sending_contribution_request,
        payment_request: state => state.payment_request,
        checkout_message: state => state.checkout_message,
        payment_request_error: state => state.payment_request_error,
    }, mutations: {
        setPaymentRequestResponse(state, val) {
            state.payment_request = val
        },
        setPaymentCheckoutResponse(state, val) {
            state.checkout_message = val
        },
        setPaymentRequestError(state, val) {
            state.payment_request_error = val
        },
        sendingContributionRequest(state, val) {
            state.sending_contribution_request = val
        },
        sendingEmailReport(state, val) {
            state.sending_report_email = val
        },
        setPayments(state, data) {
            state.payments = data;
        },
        setLoading(state, val) {
            state.loading = val
        },
        setPayment(state, data) {
            state.payment = data;
        }, setErrors(state, errors) {
            state.errors = errors
        }, hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            reference_no: [],
                            payment_date: [],
                            amount: [],
                            phone_number: [],
                            id_number: [],
                            tenant_id: [],
                            source_number: [],
                            value_date: [],
                            channel: [],
                            transaction_type: []
                        }
                    }
                };
            }
        }
    }, actions: {
        async getContributionHistory({commit}, filters) {
            try {
                commit('activateLoading', 'payment/list', {root: true});
                const response = await api.getContributionHistory(filters);
                commit('setPayments', response);
                commit('deactivateLoading', 'payment/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },

        async getPayments({commit}, filters) {
            try {
                commit('setLoading', true)
                commit('activateLoading', 'payment/list', {root: true});
                const response = await api.getPayments(filters);
                commit('setPayments', response);
                commit('setLoading', false)
                commit('deactivateLoading', 'payment/list', {root: true});
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
            }
        },

        async getPayment({commit}, id) {
            try {
                commit('activateLoading', 'payment/list', {root: true});
                const response = await api.getPayment(id);
                commit('setPayment', response.data);
                commit('deactivateLoading', 'payment/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },

        // Returns the payment directly rather than committing to shared
        // state - this feeds a transient "View Details" modal on the list
        // page, separate from the edit-page flow getPayment/setPayment above.
        async getPaymentDetails({commit}, id) {
            try {
                const response = await api.getPayment(id);
                return response.data;
            } catch (e) {
                ElMessage.error(e.response?.data?.message || 'Error fetching payment details.');
                return null;
            }
        },

        async downloadPaymentReceipt({commit}, id) {
            commit('setLoading', true)
            try {
                const response = await api.downloadPaymentReceipt(id);
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Receipt-' + id + '.pdf');
                document.body.appendChild(link);
                link.click();
                commit('setLoading', false)
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response?.data?.message || 'Error downloading receipt.');
            }
        },

        async emailPaymentReceipt({commit}, id) {
            commit('setLoading', true)
            try {
                const response = await api.emailPaymentReceipt(id);
                ElMessage.success(response?.message || 'Receipt emailed successfully.');
                commit('setLoading', false)
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response?.data?.message || 'Error emailing receipt.');
            }
        },

        async reversePayment({dispatch, commit}, {id, reason}) {
            commit('setLoading', true)
            try {
                const response = await api.reversePayment(id, reason);
                ElMessage.success(response?.message || 'Payment reversed successfully.');
                commit('setLoading', false)
                return true;
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response?.data?.message || 'Error reversing payment.');
                return false;
            }
        },

        async createPayments({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                commit('setLoading', true)
                await api.createPayments(data);
                commit('setLoading', false)
                ElMessage.success('Payment added successfully!');
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error('Error creating Payment!');
            }
        },

        async createPaymentRequest({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                commit('setLoading', true)
                const response = await api.createPaymentRequest(data);
                commit('setPaymentRequestResponse', response?.data)
                commit('setLoading', false)
                ElMessage.success('Payment request processed successfully!');
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error("We're having trouble processing your payment request. Please try again later.");
            }
        },
        async loadUnits({dispatch, commit}, data) {
            try {

                commit('setLoading', true)
                commit('hasErrors', false)
                const response = await api.loadUnits(data);
                commit('setPaymentCheckoutResponse', response)
                ElMessage.success('Request to load units successfully sent!');
                commit('setLoading', false)
                commit('setDialogVisible', false)
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error(e.response.data.message);
            }
        },
        async initiatePayment({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                commit('setLoading', true)
                const response = await api.initiatePayment(data);
                commit('setPaymentCheckoutResponse', response)
                commit('setLoading', false)
                ElMessage.success('Payment request initiated successfully!');
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error("We're having trouble processing your payment request. Please try again later.");
            }
        },

        async editPayment({dispatch}, data) {
            try {
                await api.editPayment(data);
                dispatch('getPayments', data.id);
                ElMessage.success('Payment updated successfully!');
            } catch (e) {
                ElMessage.error('Error updating Payment');
            }
        },

        async editPaymentFormData({dispatch}, data) {
            try {
                await api.editPaymentFormData(data);
                dispatch('getPayments', data.id);
                ElMessage.success('Payment updated successfully!');
            } catch (e) {
                ElMessage.error('Error updating Payment');
            }
        },

        async deletePayment({dispatch}, data) {
            try {
                await api.deletePayment(data);
                dispatch('getPayments', data.id);
                ElMessage.success('Payment removed successfully!');
            } catch (e) {
                ElMessage.error('Error removing Payment');
            }
        },

        async downloadContributionHistoryReport({commit}, filters) {
            try {

                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();
                commit('activateLoading', 'entity/list', {root: true});
                const response = await api.downloadContributionHistoryReport(filters);
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Contribution_History_Report_' + fileName + '.pdf');
                document.body.appendChild(link);
                link.click();
                commit('deactivateLoading', 'entity/list', {root: true});
            } catch (e) {
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        },

        async downloadPayments({commit}, filters) {
            try {
                const response = await api.downloadPayments(filters);
                console.log(response)
            } catch (e) {

            }
        },

        async sendContributionHistoryEmail({commit}, filters) {
            try {
                commit('sendingEmailReport', true)
                commit('activateLoading', 'payments/loading', {root: true})
                const response = await api.sendContributionHistoryEmail(filters)
                ElMessage.success("Your contribution history has been successfully sent to your email.")
                commit('sendingEmailReport', false)
            } catch (e) {
                commit('sendingEmailReport', false)
                ElMessage.error("Whoops! We encountered an error while trying to send report. Please try again later.")
            }
        },

        async getPaymentStatus({commit}, data) {
            try {
                const timer = setInterval(async () => {
                    commit('setLoading', true)
                    const response = await api.getPaymentStatus(data)
                    commit('setPaymentCheckoutResponse', response)
                    commit('setLoading', false)
                    if (response.status === 'Completed') {
                        ElMessage.success("Payment processed successfully. You will receive a confirmation shortly.")
                        clearInterval(timer)
                        setTimeout(function () {
                            if (confirm("Your payment was successful! You will receive an sms confirmation shortly.")) {
                                window.open('', '_self', '');
                                window.close();
                            }
                        }, 3000);
                    } else if (response.status === 'Failed') {
                        ElMessage.error("There was an issue processing your payment. Please try again later or contact support.")
                        clearInterval(timer)
                    }
                }, 3000)

            } catch (e) {
                commit('setLoading', false)
                ElMessage.error("There was an issue processing your payment. Please try again later or contact support.")
            }
        },

        async initiateContributionRequest({commit, dispatch}, data) {
            try {
                commit('setPaymentRequestResponse', {
                    message: ''
                })
                commit('hasErrors', false)
                commit('sendingContributionRequest', true)
                const response = await api.initiateContributionRequest(data)
                commit('sendingContributionRequest', false)
                commit('setPaymentRequestResponse', response)
                dispatch('getPaymentStatus', response.data)
            } catch (e) {
                commit('sendingContributionRequest', false)
                if (e.response.status === 422) {
                    commit('hasErrors', true)
                    commit('setErrors', e.response)
                    ElMessage.error(e.response.data.message)
                } else {
                    commit('sendingContributionRequest', false)
                    commit('setPaymentRequestError', e.response.data.message)
                    ElMessage.error("Whoops! We encountered an error while trying to initiate your contribution request. Please try again later.")
                }

            }
        },

        async exportPaymentsReport({commit}, {filters, format}) {
            try {
                commit('setLoading', true);
                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();
                const response = await api.exportPaymentsReport({...filters, format});
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Payments_Report_' + fileName + '.' + format);
                document.body.appendChild(link);
                link.click();
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        }
    }
}
